import styled from "@emotion/styled"
import { Tab } from "@mui/material"
import dynamic from "next/dynamic"

import { useCallback, useEffect, useRef, useState } from "react"
import { BuildingStepIcon, CategoryStepIcon, DestinationIcon, FileStepIcon, useIsDesktop } from "ui"
const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledLottieDiv = styled(Lottie)`
  width: 50px;
  height: 50px;
  ${(props) => props.theme.breakpoints.up("md")} {
    transform: scale(1.5);
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    width: 30px;
    height: 30px;
  }
`

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

type Props = {
  index: number
  value: any
  stepTitles: any
}

const SingleTab = ({ index, value, stepTitles }: Props) => {
  const isDesktop = useIsDesktop()
  const [animationData, setAnimationData] = useState<any>(null)
  const lottieRef = useRef<any>(null)
  const getTabColor = (index: number) => (value >= index ? "#2768A3" : "#6F6F6F")

  const getTabLabel = (index: number) =>
    isDesktop ? stepTitles[index] : value === index ? stepTitles[index] : index < 3 ? "" : " "

  // Load animation data
  useEffect(() => {
    const loadAnimation = async () => {
      if (value === index) {
        try {
          // Fetch the animation data
          const response = await fetch("/icons/StepAnimation.json")
          const data = await response.json()
          setAnimationData(data)
          // setSunAnimation(data)
        } catch (error) {
          console.error("Failed to load sun animation:", error)
        }
      }
    }

    loadAnimation()
  }, [value, index])

  const renderTabIcon = useCallback(
    (currentValue: number, stepIndex: number) => {
      const isCompleted = currentValue > stepIndex
      const isActive = currentValue >= stepIndex

      if (isCompleted) {
        return (
          animationData && (
            <StyledLottieDiv lottieRef={lottieRef} animationData={animationData} loop={false} />
          )
        )
      } else {
        if (lottieRef.current && typeof lottieRef.current.goToAndPlay === "function") {
          lottieRef.current.goToAndPlay(0, true)
        }
      }

      switch (stepIndex) {
        case 0:
          return <BuildingStepIcon />
        case 1:
          return <DestinationIcon isActive={isActive} />
        case 2:
          return <CategoryStepIcon isActive={isActive} />
        case 3:
          return <FileStepIcon isActive={isActive} />
        default:
          return undefined
      }
    },
    [animationData],
  )

  return (
    <Tab
      key={index}
      label={getTabLabel(index)}
      icon={renderTabIcon(value, index)}
      style={{ color: getTabColor(index), opacity: 1 }}
      {...a11yProps(index)}
    />
  )
}

export default SingleTab
